/** Renderiza as respostas do briefing agrupadas por bloco (só as preenchidas). */
import { BRIEFING_SCHEMA } from "@unik/shared";
import { Card, EmptyState } from "./Card";
import { STRATEGIC_BRIEFING_CHAPTERS, getBriefingValue } from "../lib/briefingResolver";

export function BriefingBlocks({ responses }: { responses: Record<string, string> }) {
  const hasAnyStrategic = STRATEGIC_BRIEFING_CHAPTERS.some((ch) =>
    ch.fields.some((f) => !!getBriefingValue(responses, f.key))
  );
  const hasAnyLegacy = BRIEFING_SCHEMA.some((sec) =>
    sec.fields.some((f) => (responses[f.key] ?? "").trim() !== "")
  );

  if (!hasAnyStrategic && !hasAnyLegacy) {
    return <EmptyState title="Ainda não preenchido" description="O briefing aparece aqui assim que for enviado." />;
  }

  return (
    <div className="flex flex-col gap-6">
      {/* Capítulos Estratégicos (Genesis Lux / ClickUp 22 perguntas) */}
      {hasAnyStrategic &&
        STRATEGIC_BRIEFING_CHAPTERS.map((chapter) => {
          const answered = chapter.fields
            .map((f) => ({ ...f, val: getBriefingValue(responses, f.key) }))
            .filter((f) => !!f.val);

          if (answered.length === 0) return null;

          return (
            <Card key={chapter.id}>
              <div className="flex items-center gap-2.5 border-b border-border-subtle/80 pb-3">
                <span
                  className="h-3 w-3 rounded-full shadow-sm"
                  style={{ backgroundColor: chapter.color }}
                />
                <h2 className="type-h3 text-text-cream">{chapter.title}</h2>
              </div>
              <div className="mt-4 flex flex-col gap-4">
                {answered.map((f) => (
                  <div key={f.key}>
                    <p className="type-label text-text-tertiary">{f.label}</p>
                    <p className="type-body-sm mt-1 whitespace-pre-wrap text-text-primary">{f.val}</p>
                  </div>
                ))}
              </div>
            </Card>
          );
        })}

      {/* Schema Legado (se houver respostas exclusivas nele) */}
      {hasAnyLegacy &&
        BRIEFING_SCHEMA.map((section) => {
          const answered = section.fields.filter((f) => (responses[f.key] ?? "").trim() !== "");
          if (answered.length === 0) return null;
          return (
            <Card key={section.key}>
              <h2 className="type-h3 text-text-cream">{section.title}</h2>
              <div className="mt-3 flex flex-col gap-4">
                {answered.map((f) => (
                  <div key={f.key}>
                    <p className="type-label text-text-tertiary">{f.label}</p>
                    <p className="type-body-sm mt-1 whitespace-pre-wrap text-text-primary">{responses[f.key]}</p>
                  </div>
                ))}
              </div>
            </Card>
          );
        })}
    </div>
  );
}
